import React from 'react';
import cx from 'classnames';

import Text from '../Text';

import styles from './TeacherStatusTag.module.scss';
import usePresenter from './TeacherStatusTag.presenter';
import getProps from './TeacherStatusTag.props';
import { TeacherStatusTagCombinedProps } from './types';
import { JourneyStatusEnum } from '../../../modules/teacher/types';


const TeacherStatusTag: React.FC<TeacherStatusTagCombinedProps> = (props) => {
  const {
    type,
    className,
    classes,
    text,
  } = usePresenter(props);

  const variantName = `${type}`;
  const internalProps = getProps(variantName);
  const currentStyle = styles[`teacherStatusTag${variantName.replace(/\s/g, '')}`];
  let componentView;

  switch (variantName) {
    //MANUAL OVERRIDE
    case JourneyStatusEnum.certified:
    case JourneyStatusEnum.graduate:
    case JourneyStatusEnum.in_training:
    case JourneyStatusEnum.under_review: {
      componentView = (
        <div className={cx(currentStyle, className)}>
          <Text
            className={cx(styles.text, classes?.text)}
            {...internalProps.text}
            {...text}/>
        </div>
      );
      break;
    }
    default:
      componentView = <div>�</div>;
      break;
  }

  return componentView;
};

export default TeacherStatusTag;

